var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnchor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 8.99992L10.3667 10.0333C9.72667 11.1599 8.14667 12.0599 6.66667 12.2799V6.33325H8.66667V4.99992H6.66667V4.21325C7.44 3.93325 8 3.19992 8 2.33325C8 1.23325 7.1 0.333252 6 0.333252C4.9 0.333252 4 1.23325 4 2.33325C4 3.19992 4.56 3.93325 5.33333 4.21325V4.99992H3.33333V6.33325H5.33333V12.2799C3.85333 12.0599 2.27333 11.1599 1.63333 10.0333L2.66667 8.99992L0 6.99992V8.99992C0 11.5866 3.28 13.6666 6 13.6666C8.72 13.6666 12 11.5866 12 8.99992V6.99992L9.33333 8.99992ZM6 1.66659C6.36667 1.66659 6.66667 1.96659 6.66667 2.33325C6.66667 2.69992 6.36667 2.99992 6 2.99992C5.63333 2.99992 5.33333 2.69992 5.33333 2.33325C5.33333 1.96659 5.63333 1.66659 6 1.66659Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchor);
export default __webpack_public_path__ + "static/media/anchor.c2865cbd02cc355cc8c6477572875f4f.svg";
export { ForwardRef as ReactComponent };